import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch, batch } from "react-redux"

import { API_URL } from '../reusable/urls'

import reply from '../reducers/reply'

// import user from '../reducers/user'

import Box from '@mui/material/Box'
import Slider from '@mui/material/Slider'

const Questions = () => {

    const accessToken = useSelector(store => store.user.accessToken)
    const username = useSelector(store => store.user.username)

    const id = useSelector(store => store.user.id)

    const dispatch = useDispatch()


    const [registered, setRegistered] = useState(false)





    // form param settings
    const [age, setAge] = useState("")
    const [gender, setGender] = useState("")
    const [diabetesType, setDiabetesType] = useState("")

    const [q1, setQ1] = useState("")
    const [diagnosisYear, setDiagnosisYear] = useState("")
    const [q2, setQ2] = useState("")
    const [q3, setQ3] = useState("")
    const [q4, setQ4] = useState("")
    const [q5, setQ5] = useState("")
    const [q6, setQ6] = useState("")
    const [q7, setQ7] = useState("")
    const [q8, setQ8] = useState("")
    const [q9, setQ9] = useState("")
    const [qA1, setQA1] = useState("")
    const [qA2, setQA2] = useState("")
    const [qA3, setQA3] = useState("")
    const [qA4r, setQA4r] = useState(1)
    const [qA5r, setQA5r] = useState(1)
    const [qA6r, setQA6r] = useState(1)
    const [qA7r, setQA7r] = useState(1)
    const [qA8r, setQA8r] = useState(1)
    const [qA9r, setQA9r] = useState(1)
    const [qA10r, setQA10r] = useState(1)
    const [qA11r, setQA11r] = useState(1)
    const [qA12r, setQA12r] = useState(1)
    const [qA13r, setQA13r] = useState(1)
    const [qA14r, setQA14r] = useState(1)
    const [qA15, setQA15] = useState("")
    const [qA16, setQA16] = useState("")
    const [qA17, setQA17] = useState("")
    const [qA18, setQA18] = useState("")
    const [qA19, setQA19] = useState("")
    const [qA20, setQA20] = useState("")
    const [qA21, setQA21] = useState("")
    const [qA22, setQA22] = useState("")
    const [qA23, setQA23] = useState("")

    const customMarks = [
        {
        value: 1,
        label: 'useless',
        },
        {
        value: 2,
        label: 'ordinary',
        },
        {
        value: 3,
        label: 'not bad',
        },
        {
        value: 4,
        label: 'handy',
        },
        {
        value: 5,
        label: 'excellent',
        }
    ]

    const isFormComplete = () => {
        if (age === "") {
          return false
        }
        if (gender === "") {
          return false
        }
        return true
      }

    const [createdAt, setCreatedAt] = useState(Date())


    const [isSubmitted, setIsSubmitted] = useState(false)
    useEffect(() => {
        setIsSubmitted(true)
        setRegistered(true)
      }, [isSubmitted, registered]);
    

    


    const onFormSubmit = (e) => {
        e.preventDefault()
        // dispatch(symptoms.actions.setLoading(true))



        // PATCH request for risk
        const optionsPatch = {
            method: "PATCH",
            headers: {
            Authorization: accessToken,
            "Content-Type": "application/json",
            },
            body: JSON.stringify({ registered }),
        }

        fetch(API_URL("user/") + id, optionsPatch)
            .then(res => res.json())
            .then(data => {
                console.log(data)
            // dispatch(symptoms.actions.setLoading(false))
            })

    
        const options = {
          // POST
          method: "POST",
          headers: {
            Authorization: accessToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username,
            createdAt,
            age,
            gender,
            diabetesType,
            q1,
            diagnosisYear,
            q2,
            q3,
            q4,
            q5,
            q6,
            q7,
            q8,
            q9,
            qA1,
            qA2,
            qA3,
            qA4r,
            qA5r,
            qA6r,
            qA7r,
            qA8r,
            qA9r,
            qA10r,
            qA11r,
            qA12r,
            qA13r,
            qA14r,
            qA15,
            qA16,
            qA17,
            qA18,
            qA19,
            qA20,
            qA21,
            qA22,
            qA23,
            isSubmitted




          })
        }
    

        fetch(API_URL("reply"), options)
            .then((res) => res.json())
            .then((data) => {
            if(data) {



                batch(() => {
                    dispatch(reply.actions.setUsername(data.username))
                    dispatch(reply.actions.setCreatedAt(data.createdAt))

                    dispatch(reply.actions.setAge(data.age))
                    dispatch(reply.actions.setGender(data.gender))
                    dispatch(reply.actions.setDiabetesType(data.diabetesType))
                    dispatch(reply.actions.setQ1(data.q1))
                    dispatch(reply.actions.setDiagnosisYear(data.diagnosisYear))
                    dispatch(reply.actions.setQ2(data.q2))
                    dispatch(reply.actions.setQ3(data.q3))
                    dispatch(reply.actions.setQ4(data.q4))
                    dispatch(reply.actions.setQ5(data.q5))
                    dispatch(reply.actions.setQ6(data.q6))
                    dispatch(reply.actions.setQ7(data.q7))
                    dispatch(reply.actions.setQ8(data.q8))

                    dispatch(reply.actions.setQ9(data.q9))

                    dispatch(reply.actions.setQA1(data.qA1))
                    dispatch(reply.actions.setQA2(data.qA2))
                    dispatch(reply.actions.setQA3(data.qA3))
                    dispatch(reply.actions.setQA4r(data.qA4r))
                    dispatch(reply.actions.setQA5r(data.qA5r))
                    dispatch(reply.actions.setQA6r(data.qA6r))
                    dispatch(reply.actions.setQA7r(data.qA7r))
                    dispatch(reply.actions.setQA8r(data.qA8r))
                    dispatch(reply.actions.setQA9r(data.qA9r))
                    dispatch(reply.actions.setQA10r(data.qA10r))
                    dispatch(reply.actions.setQA11r(data.qA11r))
                    dispatch(reply.actions.setQA12r(data.qA12r))
                    dispatch(reply.actions.setQA13r(data.qA13r))
                    dispatch(reply.actions.setQA14r(data.qA14r))
                    dispatch(reply.actions.setQA15(data.qA15))
                    dispatch(reply.actions.setQA16(data.qA16))
                    dispatch(reply.actions.setQA17(data.qA17))
                    dispatch(reply.actions.setQA18(data.qA18))
                    dispatch(reply.actions.setQA19(data.qA19))
                    dispatch(reply.actions.setQA20(data.qA20))
                    dispatch(reply.actions.setQA21(data.qA21))
                    dispatch(reply.actions.setQA22(data.qA22))
                    dispatch(reply.actions.setQA23(data.qA23))
                    dispatch(reply.actions.setIsSubmitted(data.isSubmitted))



                    // dispatch(reply.actions.setErrors(null))
                })
                
            } else {
                batch(() => {
                    dispatch(reply.actions.setErrors(data))
                    dispatch(reply.actions.setUsername(null))
                    dispatch(reply.actions.setAge(null))
                    dispatch(reply.actions.setGender(null))
                    dispatch(reply.actions.setDiabetesType(null))
                    dispatch(reply.actions.setQ1(null))
                    dispatch(reply.actions.setDiagnosisYear(null))
                    dispatch(reply.actions.setQ2(null))
                    dispatch(reply.actions.setQ3(null))
                    dispatch(reply.actions.setQ4(null))
                    dispatch(reply.actions.setQ5(null))
                    dispatch(reply.actions.setQ6(null))
                    dispatch(reply.actions.setQ7(null))
                    dispatch(reply.actions.setQ8(null))
                    dispatch(reply.actions.setQ9(null))
                    dispatch(reply.actions.setQA1(null))
                    dispatch(reply.actions.setQA2(null))
                    dispatch(reply.actions.setQA3(null))
                    dispatch(reply.actions.setQA4r(null))
                    dispatch(reply.actions.setQA5r(null))
                    dispatch(reply.actions.setQA6r(null))
                    dispatch(reply.actions.setQA7r(null))
                    dispatch(reply.actions.setQA8r(null))
                    dispatch(reply.actions.setQA9r(null))
                    dispatch(reply.actions.setQA10r(null))
                    dispatch(reply.actions.setQA11r(null))
                    dispatch(reply.actions.setQA12r(null))
                    dispatch(reply.actions.setQA13r(null))
                    dispatch(reply.actions.setQA14r(null))
                    dispatch(reply.actions.setQA15(null))
                    dispatch(reply.actions.setQA16(null))
                    dispatch(reply.actions.setQA17(null))
                    dispatch(reply.actions.setQA18(null))
                    dispatch(reply.actions.setQA19(null))
                    dispatch(reply.actions.setQA20(null))
                    dispatch(reply.actions.setQA21(null))
                    dispatch(reply.actions.setQA22(null))
                    dispatch(reply.actions.setQA23(null))
                })
                
            }

            setCreatedAt(Date())
            dispatch(reply.actions.setCreatedAt(Date()))

            setIsSubmitted(true)  
            dispatch(reply.actions.setIsSubmitted(true))

            // setRegistered(true)
            // dispatch(user.actions.setRegistered(true))
            
            


            })

        






    }    




        



    return (
        <>
            <form className="main" onSubmit={onFormSubmit}>
                

                <h3 className="main-title">
                    Welcome to diabetes e-health management questionnaire
                </h3>
                <h4 className="instructions">
                    Please answer all the questions by filling up form and scrolling down.
                    At the end of the questionnaire it will be a button "READY". Click on it to submit.
                    Please finish all the questions at once, you can not log in again to continue. 
                    After clicking on "READY" button you will be taken to new page with "Thank you" message.
                    After that you can click on "Logout" button or close the browser. All information will be saved.

                </h4>
                <h4 className="subtitle">
                    General Questions
                </h4>

                <div className="question-item-basic">
                    <h4>age</h4>
                   


                    <div className='age'>
                        <input
                            // className="gender"
                            type="radio"
                            id="under 18"
                            name="age"
                            value={age}
                            onChange={() => setAge("under 18")}
                        />
                        <label htmlFor="under 18">under 18</label>

                        <input
                            type="radio"
                            id="18-34"
                            name="age"
                            value={age}
                            onChange={() => setAge("18-34")}
                        />
                        <label htmlFor="18-34">18-34</label>

                        <input
                            type="radio"
                            id="35-49"
                            name="age"
                            value={age}
                            onChange={() => setAge("35-49")}
                        />
                        <label htmlFor="35-49">35-49</label>

                        <input
                            type="radio"
                            id="50-64"
                            name="age"
                            value={age}
                            onChange={() => setAge("50-64")}
                        />
                        <label htmlFor="50-64">50-64</label>

                        <input
                            type="radio"
                            id="65 and above"
                            name="age"
                            value={age}
                            onChange={() => setAge("65 and above")}
                        />
                        <label htmlFor="65 and above">65 and above</label>
                    </div>
                </div>





                <div className='question-item-basic'>
                    
                    <h4>gender:</h4>
                    <div>
                        <input
                            // className="gender"
                            type="radio"
                            id="male"
                            name="gender"
                            value={gender}
                            onChange={() => setGender("male")}
                        />
                        <label htmlFor="male">male</label>
                        <input
                            type="radio"
                            id="female"
                            name="gender"
                            value={gender}
                            onChange={() => setGender("female")}
                        />
                        <label htmlFor="female">female</label>
                    </div>
                </div>

                <div className="question-item">
                    <label htmlFor="q1"><h4>In what region do you live?</h4></label>
                    <textarea className={q1.length>100 ? "input-error" : "input"}
                    id="q1"
                    type="text"
                    rows="2"
                    cols="50"
                    maxLength="100"
                    value={q1}
                    onChange={(e) => setQ1(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {100 - q1.length} characters more</p>
                </div>

                <div className="question-item-year">
                    <h4>Which year you was diagnosed with diabetes?</h4>
                    <input
                    className="diagnosis-year"
                    type="number"
                    value={diagnosisYear}
                    onChange={(e) => setDiagnosisYear(e.target.value)}
                    />
                </div>

                <div className="question-item-basic">
                <h4>Diabetes type:</h4>
                    <div>
                        <input
                            type="radio"
                            id="type1"
                            name="diabetesType"
                            value={diabetesType}
                            onChange={() => setDiabetesType("type1")}
                        />
                        <label htmlFor="type1">type1</label>
                        <input
                            type="radio"
                            id="type2"
                            name="diabetesType"
                            value={diabetesType}
                            onChange={() => setDiabetesType("type2")}
                        />
                        <label htmlFor="type2">type2</label>
                    </div>
                </div>

                <div className="question-item">
                    <label htmlFor="q2">
                        <h4>
                            How do you manage your condition? 
                            e.g., insulin, other medications, dietary supplements, diet, exercise?
                            Please describe them.
                        </h4>
                    </label>
                    <textarea className={q2.length>300 ? "input-error" : "input"}
                        id="q2"
                        type="text"
                        rows="6"
                        cols="50"
                        maxLength="300"
                        value={q2}
                        onChange={(e) => setQ2(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {300 - q2.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="q3">
                        <h4>
                            How often do you check your blood sugar levels?
                        </h4>
                    </label>
                    <textarea className={q3.length>300 ? "input-error" : "input"}
                    id="q3"
                    type="text"
                    rows="6"
                    cols="50"
                    maxLength="300"
                    value={q3}
                    onChange={(e) => setQ3(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {300 - q3.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="q4">
                        <h4>
                            What is the most challenging aspect about having diabetes?
                        </h4>
                    </label>
                    <textarea className={q4.length>400 ? "input-error" : "input"}
                    id="q4"
                    type="text"
                    rows="8"
                    cols="50"
                    maxLength="400"
                    value={q4}
                    onChange={(e) => setQ4(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {400 - q4.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="q5">
                        <h4>
                            Have you ever received professional help to guide you in your diet?
                            Please tell us about your experience with dieting.
                        </h4>
                    </label>
                    <textarea className={q5.length>400 ? "input-error" : "input"}
                    id="q5"
                    type="text"
                    rows="8"
                    cols="50"
                    maxLength="400"
                    value={q5}
                    onChange={(e) => setQ5(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {400 - q5.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="q6">
                        <h4>
                            What do you think is the most challenging aspect about following a diet to manage diabetes?
                        </h4>
                    </label>
                    <textarea className={q6.length>400 ? "input-error" : "input"}
                    id="q6"
                    type="text"
                    rows="8"
                    cols="50"
                    maxLength="400"
                    value={q6}
                    onChange={(e) => setQ6(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {400 - q6.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="q7">
                        <h4>
                            Have you experienced any diabetes-related issues in the workplace?
                        </h4>
                    </label>
                    <textarea className={q7.length>300 ? "input-error" : "input"}
                    id="q7"
                    type="text"
                    rows="6"
                    cols="50"
                    maxLength="300"
                    value={q7}
                    onChange={(e) => setQ7(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {300 - q7.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="q8">
                        <h4>
                            Does the place you work/ used to work provided you with any 
                            diabetes- related support? If yes, please describe.
                        </h4>
                    </label>
                    <textarea className={q8.length>300 ? "input-error" : "input"}
                    id="q8"
                    type="text"
                    rows="6"
                    cols="50"
                    maxLength="300"
                    value={q8}
                    onChange={(e) => setQ8(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {300 - q8.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="q9">
                        <h4>
                            How comfortable are you with using technology and mobile phone apps? Have you ever 
                            used a digital app to help you with diabetes management? 
                            If yes, please tell us which app did you use or using and what was your experience.
                        </h4>
                    </label>
                    <textarea className={q9.length>500 ? "input-error" : "input"}
                    id="q9"
                    type="text"
                    rows="10"
                    cols="50"
                    maxLength="500"
                    value={q9}
                    onChange={(e) => setQ9(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {500 - q9.length} characters more</p>
                </div>

                <h4 className="subtitle">
                    GlucoNutris App Questions
                </h4>

                <div className="question-item">
                    <label htmlFor="qA1">
                        <h4>
                            What kind of features would you want an app for diabetes patients to have? 
                        </h4>
                    </label>
                    <textarea className={qA1.length>600 ? "input-error" : "input"}
                    id="qA1"
                    type="text"
                    rows="12"
                    cols="50"
                    maxLength="600"
                    value={qA1}
                    onChange={(e) => setQA1(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {600 - qA1.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="qA2">
                        <h4>
                            What is the most important aspect of dietary management for diabetes that 
                            you would like an app to assist you with? 
                        </h4>
                    </label>
                    <textarea className={qA2.length>600 ? "input-error" : "input"}
                    id="qA2"
                    type="text"
                    rows="12"
                    cols="50"
                    maxLength="600"
                    value={qA2}
                    onChange={(e) => setQA2(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {600 - qA2.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="qA3">
                        <h4>
                            How would you feel about having interactive methods, such as quizzes or trivias, as a way to learn 
                            about diabetes?  
                        </h4>
                    </label>
                    <textarea className={qA3.length>600 ? "input-error" : "input"}
                    id="qA3"
                    type="text"
                    rows="12"
                    cols="50"
                    maxLength="600"
                    value={qA3}
                    onChange={(e) => setQA3(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {600 - qA3.length} characters more</p>
                </div>

                <h4 className="sub-subtitle">
                    Please, rate how useful do you find the following features for a mobile app that helps you 
                    to manage your diet (1- useless, 5- excellent): 
                </h4>
                

                <div className="question-item">
                    <label htmlFor="qA4r">
                        <h4>
                            Acquiring knowledge about diabetes through interactive methods. 
                            Please rate on the scale from useless(1) to excellent(5) 
                        </h4>
                    </label>
                    <Box>
                        <Slider
                            name = "slider_qA4r"
                            style={{ width: 270, margin: "auto" }}
                            aria-label="Always visible"
                            min={1}
                            max={5}
                            step={1}
                            value={qA4r}
                            marks={customMarks}
                            onChange={(e) => setQA4r(e.target.value)}
                            valueLabelDisplay="auto"
                        />
                    </Box>
                </div>

                <div className="question-item">
                    <label htmlFor="qA5r">
                        <h4>
                            Getting a nutritional evaluation and your dietary requirements calculated. 
                            Please rate on the scale from useless(1) to excellent(5) 
                        </h4>
                    </label>
                    <Box>
                        <Slider
                            name = "slider_qA5r"
                            style={{ width: 270, margin: "auto" }}
                            aria-label="Always visible"
                            min={1}
                            max={5}
                            step={1}
                            value={qA5r}
                            marks={customMarks}
                            onChange={(e) => setQA5r(e.target.value)}
                            valueLabelDisplay="auto"
                        />
                    </Box>
                </div>

                <div className="question-item">
                    <label htmlFor="qA6r">
                        <h4>
                            Getting your personalized meal plan. 
                            Please rate on the scale from useless(1) to excellent(5) 
                        </h4>
                    </label>
                    <Box>
                        <Slider
                            name = "slider_qA6r"
                            style={{ width: 270, margin: "auto" }}
                            aria-label="Always visible"
                            min={1}
                            max={5}
                            step={1}
                            value={qA6r}
                            marks={customMarks}
                            onChange={(e) => setQA6r(e.target.value)}
                            valueLabelDisplay="auto"
                        />
                    </Box>
                </div>

                <div className="question-item">
                    <label htmlFor="qA7r">
                        <h4>
                            Registering your meals. 
                            Please rate on the scale from useless(1) to excellent(5) 
                        </h4>
                    </label>
                    <Box>
                        <Slider
                            name = "slider_qA7r"
                            style={{ width: 270, margin: "auto" }}
                            aria-label="Always visible"
                            min={1}
                            max={5}
                            step={1}
                            value={qA7r}
                            marks={customMarks}
                            onChange={(e) => setQA7r(e.target.value)}
                            valueLabelDisplay="auto"
                        />
                    </Box>
                </div>

                <div className="question-item">
                    <label htmlFor="qA8r">
                        <h4>
                            Keeping track of your physical activity. 
                            Please rate on the scale from useless(1) to excellent(5) 
                        </h4>
                    </label>
                    <Box>
                        <Slider
                            name = "slider_qA8r"
                            style={{ width: 270, margin: "auto" }}
                            aria-label="Always visible"
                            min={1}
                            max={5}
                            step={1}
                            value={qA8r}
                            marks={customMarks}
                            onChange={(e) => setQA8r(e.target.value)}
                            valueLabelDisplay="auto"
                        />
                    </Box>
                </div>

                <div className="question-item">
                    <label htmlFor="qA9r">
                        <h4>
                            Having online consultations with dieticians. 
                            Please rate on the scale from useless(1) to excellent(5) 
                        </h4>
                    </label>
                    <Box>
                        <Slider
                            name = "slider_qA9r"
                            style={{ width: 270, margin: "auto" }}
                            aria-label="Always visible"
                            min={1}
                            max={5}
                            step={1}
                            value={qA9r}
                            marks={customMarks}
                            onChange={(e) => setQA9r(e.target.value)}
                            valueLabelDisplay="auto"
                        />
                    </Box>
                </div>

                <div className="question-item">
                    <label htmlFor="qA10r">
                        <h4>
                            Receiving a personalized grocery shopping list for a weakly choice 
                            of your meals. 
                            Please rate on the scale from useless(1) to excellent(5) 
                        </h4>
                    </label>
                    <Box>
                        <Slider
                            name = "slider_qA10r"
                            style={{ width: 270, margin: "auto" }}
                            aria-label="Always visible"
                            min={1}
                            max={5}
                            step={1}
                            value={qA10r}
                            marks={customMarks}
                            onChange={(e) => setQA10r(e.target.value)}
                            valueLabelDisplay="auto"
                        />
                    </Box>
                </div>

                <div className="question-item">
                    <label htmlFor="qA11r">
                        <h4>
                            Getting a weakly menu suggestions with recipes. 
                            Please rate on the scale from useless(1) to excellent(5) 
                        </h4>
                    </label>
                    <Box>
                        <Slider
                            name = "slider_qA11r"
                            style={{ width: 270, margin: "auto" }}
                            aria-label="Always visible"
                            min={1}
                            max={5}
                            step={1}
                            value={qA11r}
                            marks={customMarks}
                            onChange={(e) => setQA11r(e.target.value)}
                            valueLabelDisplay="auto"
                        />
                    </Box>
                </div>

                <div className="question-item">
                    <label htmlFor="qA12r">
                        <h4>
                            Access to a pool of recipes. 
                            Please rate on the scale from useless(1) to excellent(5) 
                        </h4>
                    </label>
                    <Box>
                        <Slider
                            name = "slider_qA12r"
                            style={{ width: 270, margin: "auto" }}
                            aria-label="Always visible"
                            min={1}
                            max={5}
                            step={1}
                            value={qA12r}
                            marks={customMarks}
                            onChange={(e) => setQA12r(e.target.value)}
                            valueLabelDisplay="auto"
                        />
                    </Box>
                </div>

                <div className="question-item">
                    <label htmlFor="qA13r">
                        <h4>
                            Keeping track of your blood sugar measurements. 
                            Please rate on the scale from useless(1) to excellent(5) 
                        </h4>
                    </label>
                    <Box>
                        <Slider
                            name = "slider_qA13r"
                            style={{ width: 270, margin: "auto" }}
                            aria-label="Always visible"
                            min={1}
                            max={5}
                            step={1}
                            value={qA13r}
                            marks={customMarks}
                            onChange={(e) => setQA13r(e.target.value)}
                            valueLabelDisplay="auto"
                        />
                    </Box>
                </div>

                <div className="question-item">
                    <label htmlFor="qA14r">
                        <h4>
                            Tracking your pulse and blood pressure. 
                            Please rate on the scale from useless(1) to excellent(5) 
                        </h4>
                    </label>
                    <Box>
                        <Slider
                            name = "slider_qA14r"
                            style={{ width: 270, margin: "auto" }}
                            aria-label="Always visible"
                            min={1}
                            max={5}
                            step={1}
                            value={qA14r}
                            marks={customMarks}
                            onChange={(e) => setQA14r(e.target.value)}
                            valueLabelDisplay="auto"
                        />
                    </Box>
                </div>

                <h4 className="sub-subtitle">
                    We also would like to ask your opinion about the following: 
                </h4>

                <div className="question-item">
                    <label htmlFor="qA15">
                        <h4>
                            Do you want an app which gives you options for different diets (e.g. Mediterranean, keto,
                            whole food, gluten- free, vegetarian) or one that tailors a meal plan based on your personal
                            preferences?  
                        </h4>
                    </label>
                    <textarea className={qA15.length>300 ? "input-error" : "input"}
                    id="qA15"
                    type="text"
                    rows="6"
                    cols="50"
                    maxLength="300"
                    value={qA15}
                    onChange={(e) => setQA15(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {300 - qA15.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="qA16">
                        <h4>
                            Would you like the option to easily find and select meals with a minimal number of 
                            ingredients or shortest cooking time?  
                        </h4>
                    </label>
                    <textarea className={qA16.length>300 ? "input-error" : "input"}
                    id="qA16"
                    type="text"
                    rows="6"
                    cols="50"
                    maxLength="300"
                    value={qA16}
                    onChange={(e) => setQA16(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {300 - qA16.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="qA17">
                        <h4>
                            Would you like the option to join a community within the app where you can 
                            talk to other people who have diabetes and get help from healthcare experts? 
                        </h4>
                    </label>
                    <textarea className={qA17.length>300 ? "input-error" : "input"}
                    id="qA17"
                    type="text"
                    rows="6"
                    cols="50"
                    maxLength="300"
                    value={qA17}
                    onChange={(e) => setQA17(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {300 - qA17.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="qA18">
                        <h4>
                            Do you think it would be helpful to have a rewards program for staying on 
                            track with your diet plan? Such as receiving gifts, discounts on workout equipment 
                            or additional consultations with dieticians or may be you have your own suggestions?
                        </h4>
                    </label>
                    <textarea className={qA18.length>600 ? "input-error" : "input"}
                    id="qA18"
                    type="text"
                    rows="12"
                    cols="50"
                    maxLength="600"
                    value={qA18}
                    onChange={(e) => setQA18(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {600 - qA18.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="qA19">
                        <h4>
                            Would it be beneficial for you to have the option to schedule regular check-ins 
                            with a dietician through the app?
                        </h4>
                    </label>
                    <textarea className={qA19.length>300 ? "input-error" : "input"}
                    id="qA19"
                    type="text"
                    rows="6"
                    cols="50"
                    maxLength="300"
                    value={qA19}
                    onChange={(e) => setQA19(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {300 - qA19.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="qA20">
                        <h4>
                            What kind of help from a digital health app that assists you in managing 
                            diabetes through diet, would make you more likely to stick to lifestyle changes?
                            Please elaborate.
                        </h4>
                    </label>
                    <textarea className={qA20.length>600 ? "input-error" : "input"}
                    id="qA20"
                    type="text"
                    rows="12"
                    cols="50"
                    maxLength="600"
                    value={qA20}
                    onChange={(e) => setQA20(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {600 - qA20.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="qA21">
                        <h4>
                            Could you tell us if you would enjoy a feature that allows users to create and share 
                            their own dish recipes? With the added benefit of the recipes being reviewed by a dietician 
                            before they are published? And also, how do you think this feature would help keep users 
                            engaged with the application? 
                        </h4>
                    </label>
                    <textarea className={qA21.length>600 ? "input-error" : "input"}
                    id="qA21"
                    type="text"
                    rows="12"
                    cols="50"
                    maxLength="600"
                    value={qA21}
                    onChange={(e) => setQA21(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {600 - qA21.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="qA22">
                        <h4>
                            Which specific features of the app would you consider worth paying for? 
                        </h4>
                    </label>
                    <textarea className={qA22.length>600 ? "input-error" : "input"}
                    id="qA22"
                    type="text"
                    rows="12"
                    cols="50"
                    maxLength="600"
                    value={qA22}
                    onChange={(e) => setQA22(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {600 - qA22.length} characters more</p>
                </div>

                <div className="question-item">
                    <label htmlFor="qA23">
                        <h4>
                            Is there anything else you would like to share? 
                        </h4>
                    </label>
                    <textarea className={qA23.length>800 ? "input-error" : "input"}
                    id="qA23"
                    type="text"
                    rows="16"
                    cols="50"
                    maxLength="800"
                    value={qA23}
                    onChange={(e) => setQA23(e.target.value)}
                    >    
                    </textarea>
                    <p className="time-from-now">you can type {800 - qA23.length} characters more</p>
                </div>

                <button
                    type="submit"
                    className="form-submit-btn"
                    disabled={!isFormComplete()}
                >
                    Submit
                </button>
            </form>
        </>
    )
}

export default Questions